import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './DestinationsSection.css';

function DestinationsSection() {
  const [hoveredDestination, setHoveredDestination] = useState(null);

  const destinations = [
    {
      name: 'Arusha National Park',
      image: '/assets/imgs/destination/arusha-national-park.jpg',
      description: 'A diverse ecosystem with lush forests, wildlife, and stunning landscapes.',
      highlights: [
        'Diverse wildlife including giraffes and colobus monkeys',
        'Stunning Mount Meru backdrop',
        'Varied landscapes from rainforest to alpine desert'
      ]
    },
    {
      name: 'Lake Manyara National Park',
      image: '/assets/imgs/destination/lake-manyara.jpg',
      description: 'Famous for its tree-climbing lions and diverse birdlife.',
      highlights: [
        'Unique tree-climbing lions',
        'Massive flamingo populations',
        'Scenic lake views and diverse ecosystems'
      ]
    },
    {
      name: 'Ndutu Plains',
      image: '/assets/imgs/destination/ndutu.jpg',
      description: 'Witness the great wildebeest migration and abundant wildlife.',
      highlights: [
        'Wildebeest migration hotspot',
        'Vast open plains',
        'Excellent predator viewing'
      ]
    },
    {
      name: 'Ngorongoro Crater',
      image: '/assets/imgs/destination/ngorongoro1.jpg',
      description: 'A UNESCO World Heritage site with incredible wildlife density.',
      highlights: [
        'World\'s largest intact volcanic caldera',
        'High concentration of wildlife',
        'Home to endangered black rhinos'
      ]
    },
    {
      name: 'Northern Serengeti',
      image: '/assets/imgs/destination/manyara.jpg',
      description: 'Pristine wilderness and home to the dramatic river crossings.',
      highlights: [
        'Dramatic wildebeest river crossings',
        'Remote and less crowded',
        'Abundant wildlife year-round'
      ]
    },
    {
      name: 'Serengeti National Park',
      image: '/assets/imgs/destination/serengeti1.jpg',
      description: 'Iconic safari destination with endless plains and abundant wildlife.',
      highlights: [
        'Endless savannah landscapes',
        'Home to the great migration',
        'Incredible predator populations'
      ]
    },
    {
      name: 'Tarangire National Park',
      image: '/assets/imgs/destination/tarangire1.jpg',
      description: 'Known for its large elephant herds and baobab trees.',
      highlights: [
        'Massive elephant herds',
        'Iconic baobab trees',
        'Seasonal wildlife migrations'
      ]
    },
    {
      name: 'Zanzibar Island',
      image: '/assets/imgs/destination/zanzibar.jpeg',
      description: 'Tropical paradise with white sandy beaches and rich cultural heritage.',
      highlights: [
        'Pristine white sandy beaches',
        'Rich Swahili cultural heritage',
        'Historic Stone Town UNESCO site'
      ]
    },
    {
      name: 'Ruaha National Park',
      image: '/assets/imgs/destination/ruaha.webp',
      description: 'Tanzania\'s largest national park with diverse wildlife and stunning landscapes.',
      highlights: [
        'Largest national park in Tanzania',
        'High concentration of elephants',
        'Remote and unspoiled wilderness'
      ]
    },
    {
      name: 'Nyerere National Park',
      image: '/assets/imgs/destination/nyerere.jpg',
      description: 'Formerly Selous Game Reserve, one of Africa\'s largest protected areas.',
      highlights: [
        'One of Africa\'s largest game reserves',
        'Excellent walking safari opportunities',
        'Diverse ecosystems and wildlife'
      ]
    },
    {
      name: 'Mikumi National Park',
      image: '/assets/imgs/destination/mikumi.jpg',
      description: 'Accessible park with abundant wildlife and beautiful savannah landscapes.',
      highlights: [
        'Easy accessibility from Dar es Salaam',
        'Large herds of elephants and buffalo',
        'Open grasslands perfect for game viewing'
      ]
    },
    {
      name: 'Mount Meru',
      image: '/assets/imgs/destination/mount-meru.webp',
      description: 'Tanzania\'s second highest peak offering challenging climbs and stunning views.',
      highlights: [
        'Tanzania\'s second highest peak (4,566m)',
        'Less crowded than Kilimanjaro',
        'Stunning views of Kilimanjaro'
      ]
    },
    {
      name: 'Mafia Island',
      image: '/assets/imgs/destination/Mafia_Island_Whale_Shark_04.jpg',
      description: 'Pristine island paradise with world-class diving and marine life.',
      highlights: [
        'World-class diving and snorkeling',
        'Marine protected area',
        'Pristine beaches and clear waters'
      ]
    },
    {
      name: 'Pemba Island',
      image: '/assets/imgs/destination/pemba.jpeg',
      description: 'The "Green Island" known for its lush vegetation and excellent diving.',
      highlights: [
        'Excellent diving and snorkeling',
        'Lush green landscapes',
        'Authentic Swahili culture'
      ]
    },
    {
      name: 'Gombe Stream National Park',
      image: '/assets/imgs/destination/Gombe.jpeg',
      description: 'Famous for chimpanzee tracking and Jane Goodall\'s research.',
      highlights: [
        'Chimpanzee tracking opportunities',
        'Jane Goodall\'s research site',
        'Dense forest and waterfalls'
      ]
    }
  ];

  return (
    <section className="destinations-section">
      <div className="destinations-container">
        <h2 className="destinations-title">Explore Our Destinations</h2>
        <p className="destinations-subtitle">
          Discover the breathtaking landscapes and incredible wildlife of Tanzania
        </p>
        
        <div className="destinations-grid">
          {destinations.map((destination, index) => (
            <div 
              key={index} 
              className="destination-card"
              onMouseEnter={() => setHoveredDestination(index)}
              onMouseLeave={() => setHoveredDestination(null)}
            >
              <div className="destination-image-container">
                <img 
                  src={destination.image} 
                  alt={destination.name} 
                  className="destination-image"
                />
                <div className="destination-overlay">
                  <h3 className="destination-name">{destination.name}</h3>
                </div>
                
                <div 
                  className={`destination-hover-details ${
                    hoveredDestination === index ? 'visible' : ''
                  }`}
                >
                  <h4>{destination.name}</h4>
                  <p>{destination.description}</p>
                  <ul>
                    {destination.highlights.map((highlight, highlightIndex) => (
                      <li key={highlightIndex}>{highlight}</li>
                    ))}
                  </ul>
                  <Link 
                    to={`/destinations/${destination.name.toLowerCase().replace(/\s+/g, '-')}`} 
                    className="btn btn-small"
                  >
                    Explore {destination.name}
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="destinations-cta">
          <Link to="/destinations" className="btn">View All Destinations</Link>
        </div>
      </div>
    </section>
  );
}

export default DestinationsSection;
